module.exports = __webpack_public_path__ + "assets/img/xinjianghua_519_1.8ff7a694.jpg";